import { createContext } from 'react';

import noop from 'lodash/noop';

// What a card can do in the chat it is shown in. Laila's chat provides it;
// a card shown anywhere else is read-only.
export interface LailaCardActions {
  // A card the user acted on (picked, sent, cancelled) keeps its new data
  // where it is in the chat. A function gets the card's current data, for
  // updates that may overlap.
  updateCard: (
    id: string,
    data: Record<string, unknown> | ((current: Record<string, unknown>) => Record<string, unknown>)
  ) => void;
  // What the user did on a card, for Laila to know with the next question.
  noteForLaila: (note: string) => void;
  // Answers Laila's question from the card, as if the user said it: in the
  // chat a message, in voice mode the next question. None where it can't.
  answer?: (text: string) => void;
  // Goes to a page of the app; where the chat is a panel over the page, it
  // closes first. Without it, cards navigate with the router.
  openPage?: (path: string) => void;
}

export const LailaCardsContext = createContext<LailaCardActions>({ updateCard: noop, noteForLaila: noop });
